import { css } from 'aphrodite';
import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { FormFieldType, IFormField } from '../../../../../../extViewmodels';
import KanbanBoardColumnDefinitionGripIconUrl from '../../../../../components/boards/EditBoardColumnDefinition/kanbanBoardColumnDefinitionGrip.svg';
import { styleSheet } from './styles';

interface IProps {
	question: IFormField<string>;
	index: number;
	/** Label like "Depends on Question 3" when this question has a visibility condition */
	dependencyLabel?: string;
}

const getFieldTypeLabel = (fieldType: FormFieldType): string => {
	switch (fieldType) {
		case FormFieldType.String:
			return 'Text';
		case FormFieldType.Date:
			return 'Date';
		case FormFieldType.Option:
			return 'Single Choice';
		case FormFieldType.MultipleOptions:
			return 'Multiple Choice';
		case FormFieldType.Boolean:
			return 'Yes/No';
		default:
			return 'Text';
	}
};

export const ReorderQuestionItem: React.FC<IProps> = ({ question, index, dependencyLabel }) => {
	return (
		<Draggable draggableId={question.id} index={index}>
			{(provided, snapshot) => (
				<div
					ref={provided.innerRef}
					{...provided.draggableProps}
					className={css(styleSheet.reorderQuestionItem, snapshot.isDragging ? styleSheet.isDragging : undefined)}
				>
					<div className={css(styleSheet.reorderQuestionDragHandle)}>
						<img {...provided.dragHandleProps} src={KanbanBoardColumnDefinitionGripIconUrl} />
					</div>
					<div className={css(styleSheet.reorderQuestionNumber)}>{index + 1}</div>
					<div className={css(styleSheet.reorderQuestionContent)}>
						<div className={css(styleSheet.reorderQuestionLabel)}>{question.label?.trim() || 'Untitled Question'}</div>
						<div className={css(styleSheet.reorderQuestionType)}>
							{getFieldTypeLabel(question.fieldType)}
							{question.isOptional && ' (Optional)'}
						</div>
						{dependencyLabel && <div className={css(styleSheet.reorderQuestionDependency)}>{dependencyLabel}</div>}
					</div>
				</div>
			)}
		</Draggable>
	);
};
